import { defineMessages } from "react-intl";

export const giftCardListOrderCardMessages = defineMessages({
  giftCardOrderInfoMessage: {
    id: "31hYP2",
    defaultMessage:
      "Gift cards will appear after their order is fullfilled. <link>View Orders with Gift Cards</link>",
    description: "alert card message",
  },
});
